import React from 'react';
import { Grid, Button, Typography, IconButton, Tooltip, Stack } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DownloadIcon from '@mui/icons-material/Download';
import dayjs from 'dayjs';

function FooterButtons({
  booking,
  hasOverrideCapacityRights = false,
  isEditable = false,
  onOpenCapacityOverrideDialog,
  onCommunicationHistoryOpen,
  onInvoiceModalOpen,
  onOnSiteProtocolModalOpen,
  onPaymentHistoryModalOpen,
  onBookingHistoryModalOpen,
  onExternalInvoiceCreate,
  externalInvoice,
  onExternalInvoiceView,
  onExternalInvoiceDownload,
}) {
  const hasCapacityOverride =
    (typeof booking?.capacityParticipantCount === 'number' &&
      booking.capacityParticipantCount >= 0) ||
    (typeof booking?.capacityLaneCount === 'number' && booking.capacityLaneCount >= 0);

  const showCapacityOverrideButton =
    hasOverrideCapacityRights && isEditable && !hasCapacityOverride;

  const isExternallyManaged = Boolean(booking?.entertainmentId?.isExternallyManaged);

  return (
    <>
      {booking.status !== 'blocked' && (
        <Grid container spacing={1} mt={2}>
          <Grid item xs={12} sm={6} lg={4}>
            <Button variant='outlined' size='small' onClick={onCommunicationHistoryOpen} fullWidth>
              Kommunikationsverlauf
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <Button variant='outlined' size='small' onClick={onBookingHistoryModalOpen} fullWidth>
              Änderungsverlauf
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <Button variant='outlined' size='small' onClick={onOnSiteProtocolModalOpen} fullWidth>
              Aktivitätsverlauf
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} lg={showCapacityOverrideButton ? 4 : 6}>
            <Button variant='outlined' size='small' onClick={onPaymentHistoryModalOpen} fullWidth>
              Online-Zahlungen
            </Button>
          </Grid>
          <Grid
            item
            xs={12}
            sm={showCapacityOverrideButton ? 6 : 12}
            lg={showCapacityOverrideButton ? 4 : 6}
          >
            <Button variant='outlined' size='small' onClick={onInvoiceModalOpen} fullWidth>
              Rechnungen
            </Button>
          </Grid>
          {showCapacityOverrideButton && (
            <Grid item xs={12} sm={6} lg={4}>
              <Button
                variant='outlined'
                size='small'
                onClick={onOpenCapacityOverrideDialog}
                fullWidth
              >
                Kapazitätsübersteuerung hinzufügen
              </Button>
            </Grid>
          )}
          {isExternallyManaged && !externalInvoice && onExternalInvoiceCreate && (
            <Grid item xs={12}>
              <Button
                variant='outlined'
                size='small'
                onClick={onExternalInvoiceCreate}
                fullWidth
              >
                Rechnung erstellen
              </Button>
            </Grid>
          )}
          {isExternallyManaged && externalInvoice && (
            <Grid item xs={12}>
              <Stack direction='row' spacing={1}>
                <Button
                  variant='outlined'
                  size='small'
                  startIcon={<VisibilityIcon />}
                  onClick={onExternalInvoiceView}
                  fullWidth
                >
                  Rechnung anzeigen
                </Button>
                <Button
                  variant='outlined'
                  size='small'
                  startIcon={<DownloadIcon />}
                  onClick={onExternalInvoiceDownload}
                  fullWidth
                >
                  Rechnung herunterladen
                </Button>
              </Stack>
            </Grid>
          )}
        </Grid>
      )}
      {booking.meta && (
        <Typography
          variant='caption'
          color='text.secondary'
          sx={{
            mt: 1,
            display: 'block',
            fontSize: '0.75rem',
            color: 'grey.500',
          }}
        >
          Erstellt am {dayjs(booking.meta.createdAt).format('DD.MM.YYYY HH:mm')} von{' '}
          {booking.meta.createdBy}
          {booking.meta.editedAt && booking.meta.editedBy && (
            <>
              <br />
              Zuletzt bearbeitet am {dayjs(booking.meta.editedAt).format(
                'DD.MM.YYYY HH:mm'
              )} von {booking.meta.editedBy}
            </>
          )}
        </Typography>
      )}
    </>
  );
}

export default FooterButtons;
